<template>
  <progress-bar
    :display-back="true"
    :image-source="levelComponent.progress"
    @quit="$emit('quit')"
  />
  <scrollable-content>
    <div class="question">{{ $t(question.text) }}</div>
    <answers>
      <template v-for="(answer, idx) in levelComponent.answers">
        <answer
          :key="idx"
          :answer="answer"
          v-if="hasAnswerDependencyValues(answer)">
          {{ $t(answer.text) }}
        </answer>
      </template>
    </answers>
    <div
      class="advice-wrapper"
      v-if="$te(advice)">
      <img
        class="advice-image"
        :src="currentAdvisorPath"
      />
      <div class="advice-arrow" />
      <div
        class="advice"
        v-html="$t(advice)"
      />
    </div>
  </scrollable-content>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        values: 'answers',
        advisorIcon: 'advisorIcon',
        advisorIcons: 'advisorIcons',
      }),
      currentAdvisorPath() {
        let currentAdvisor = this.advisorIcon
        if (currentAdvisor) {
          let ca = this.advisorIcons.find(advisor => advisor.id === currentAdvisor)
          if (ca) {
            return ca.icon
          }
        }
      },
      question() {
        return this.levelComponent?.questions?.find(question => {
          if (!question.depends) {
            return true
          }

          let results = question.depends.filter(value => {
            return this.values.indexOf(value) > -1
          })
          return question.depends.length === 1
            ? results.length >= 1
            : results.length === question.depends.length

          // When depends === 1 it needs to be atleast this answer in all answers
          // When depends > 1 and < results it needs to be all of these
          // When depends === results it needs to be all of these
        })
      },
      advice() {
        return this.question?.advice
      }
    },
    methods: {
      hasAnswerDependencyValues(answer) {
        if (answer.depends) {
          let results = answer.depends.filter(value => {
             return this.values.indexOf(value) > -1
          })
          return answer.depends.length === 1
            ? results.length >= 1
            : results.length === answer.depends.length
        }

        if (answer.orDepends) {
          return answer.orDepends.some(value => this.values.includes(value))
        }
        return true
      }
    },
    emits: [
      'setWindowMode',
      'quit'
    ]
  }
</script>

<style lang="scss" scoped>
  .advice-wrapper {
    @apply
      px-7
      pb-7
      flex
      items-end;

    .advice-image {
      @apply
        w-15
        h-15
        p-2
        flex-grow-0
        object-cover
        flex-shrink-0;
    }

    .advice-arrow {
      @apply
        w-2
        h-2
        mb-6
        inline
        border-6
        bg-transparent
        border-ctm-primary;
        border-top-color: transparent;
        border-left-color: transparent;
        border-bottom-color: transparent;
    }

    .advice {
      @apply
        py-1
        px-2
        w-full
        text-sm
        rounded
        shadow-ctm;
    }
  }

  .question {
    @apply
    py-5
    px-10
    text-xl
    bg-white
    text-center
    text-ctm-primary;
  }
</style>
